<template>
  <div class="container">
    <div class="image-nav">
      <div 
        v-for="(item, index) in subjectNavList" 
        :key="index" 
        class="image-item" 
        @click="navigateToPage(item)"
      >
        <img :src="item.imageUrl" alt="" />
        <span>{{ item.titleName }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>

import { useRouter } from 'vue-router'	
import { ref } from 'vue'
// ✅ 正确：在顶部调用 useRouter() 获取路由实例对象
const router = useRouter()
// 响应式数据
const subjectNavList = ref([
{
    imageUrl: './pic/brain.png',
    titleName: '聪明大脑',
    name: 'brain',
    navigatetopageurl: '/brain-video'
  },
  {
    imageUrl: './pic/zhiyuan.png',
    titleName: '学/职业规划',
    name: 'EducationPlanning',
    navigatetopageurl: '/EducationPlanning-home',
    
  },
  {
    imageUrl: './pic/english.png',
    titleName: '应试英语',
    name: 'english',
    navigatetopageurl: '/to-pagegrade'
  },
  {
    imageUrl: './pic/math.png',
    titleName: '应试数学',
    name: 'math',
    navigatetopageurl: '/to-pagegrade'
  },
  {
    imageUrl: './pic/chemistry.png',
    titleName: '化学',
    name: 'chemistry',
    navigatetopageurl: '/to-pagegrade'
  },
  {
    imageUrl: './pic/Physics.png',
    titleName: '物理',
    name: 'Physics',
    navigatetopageurl: '/to-pagegrade'
  },
  {
    imageUrl: './pic/family.png',
    titleName: '家庭教育',
    name: 'family',
    navigatetopageurl: '/to-page-familyedu'
  },
  {
    imageUrl: './pic/boardGame.png',
    titleName: '智星棋社',
    name: 'boardGame',
    navigatetopageurl: '/to-pagegrade'
  },
  {
    imageUrl: './pic/lanting.png',
    titleName: '兰亭书画',
    name: 'lanting',
    navigatetopageurl: '/to-pagegrade'
  },
  {
    imageUrl: './pic/lanting.png',
    titleName: 'ceshi',
    name: 'test',
    navigatetopageurl: '/to-page-video-from-net',
    videosrc: 'https://page.om.qq.com/page/OIkJ06makRyMrulXUI0MD6cg0'
  }
])

// 方法
const navigateToPage = (item) => {
  // 如果是需要筛选的页面（如 /to-pagegrade），携带学科参数
    if (item.navigatetopageurl === '/to-pagegrade'||item.navigatetopageurl === '/to-page-video-from-net') {
      router.push({
        path: item.navigatetopageurl,
        query: {     name: item.name,
                 videosrc: item.videosrc} // 动态使用当前项的 subject
      })
    } else {
      // 其他页面直接跳转，不需要参数
      router.push(item.navigatetopageurl)
    }
 
}
</script>

<style scoped>
	
/* 这个是总div的样式 整个导航页面的最外面的大容器*/	
.container {
  padding: 20px;
  
  min-height: 200px;
}

.image-nav {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 15px;
}

.image-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  width: 80px;
}

.image-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.image-item img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  margin-bottom: 8px;
}

.image-item span {
  font-size: 12px;
  color: #333;
  text-align: center;
}
/* 电脑端专属：控制轮播图大小（屏幕≥1024px时生效） */
@media (min-width: 1024px) {
  /* 限制中间显示区宽度为手机竖屏常见宽度（如375px，可修改） */
  .container {
    max-width: 500px !important; /* 中间显示区宽度（手机常见宽度） */
    margin: 20px auto !important; /* 左右自动留白，居中显示 */
  }
}
</style>